import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import YMap from "../components/Map";
import CustomSelect from "../components/CustomSelect";
import InWorkPanel from "../components/InWorkPanel";
import WaitForCallPanel from "../components/WaitForCallPanel";
import { loadPlacemarks } from "../actions/mapActions";
import {
  loadClientsInWorkFullList,
  loadClientInProfit,
  loadWaitCallClients,
  loadClients
} from "../actions/clientsActions";
import { loadFilters } from "../actions/filtersAction";
import SearchFilters from "../components/SearchFilters/";

class SearchPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      types: [],
      filterCoords: [],
      placemarksForMap: props.placemarks
    };
    this.handleFormFilterChange = this.handleFormFilterChange.bind(this);
  }

  filter = {};

  avalaybleTypes = [];

  coords = [];

  componentDidMount() {
    this.props.loadPlacemarks();
    this.props.loadClientsInWorkFullList();
    this.props.loadClientInProfit();
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.placemarks.length &&
      !nextProps.isPlacemarksLoading &&
      !this.avalaybleTypes.length
    ) {
      this.avalaybleTypes = nextProps.clientTypes.filter(type =>
        nextProps.placemarks.find(
          pm => pm.type == this.getCorrelateType(type.label)
        )
      );
    }
  }

  handleFilterChange = (name, value) => {
    this.setState({
      types: value
    });
  };

  handleFormFilterChange(filter, paginator) {
    this.props.loadFilters(filter);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.filters &&
      prevProps.filters &&
      this.props.filters.length !== prevProps.filters.length
    ) {
      this.takeCoords();
    }
  }

  takeCoords = () => {
    this.setState({
      filterCoords: []
    });
    this.props.filters.map(i => {
      let item = {
        id: i.id,
        name: i.name,
        coords: [i.lat, i.lon],
        type: i.type
      };
      this.setState(prevState => ({
        filterCoords: [...prevState.filterCoords, item]
      }));
    });
  };
  getCorrelateType = type => {
    switch (type) {
      case "Элеватор":
      case "3":
        return "elevator";
      case "Клиент":
      case "2":
        return "client";
      case "Поставщик":
      case "1":
        return "supplier";
      default:
        return "";
    }
  };

  filterPlacemarks = () => {
    const { placemarks } = this.props;
    const { filterCoords } = this.state;

    if (!filterCoords.length) return placemarks;
    return filterCoords;
  };

  renderType = () => {
    if (this.avalaybleTypes !== undefined && this.avalaybleTypes.length < 2) {
      return (
        <span style={{ width: "62%" }}>{this.avalaybleTypes[0].label}</span>
      );
    } else {
      return (
        <CustomSelect
          placeholder="Выберите тип"
          options={this.avalaybleTypes}
          name="types"
          onSelect={this.handleFilterChange}
          values={this.state.types}
          multiple
        />
      );
    }
  };

  render() {
    const {
      isPlacemarksLoading,
      loading,
      clients,
      inProfitClients,
      clientsListType,
      profitListType
    } = this.props;
    return (
      <div>
        {loading ? null : (
          <div className="container-search-page">
            {profitListType === "list" ? (
              <div>
                {!inProfitClients.length ? null : (
                  <div className="row mr-bottom-20">
                    <h2>В работе</h2>
                    <WaitForCallPanel
                      list={inProfitClients}
                      className={"info"}
                    />
                  </div>
                )}
              </div>
            ) : (
              <div>
                {inProfitClients ? (
                  <div className="row mr-bottom-20">
                    <InWorkPanel title="В работе" list={inProfitClients} />
                  </div>
                ) : null}
              </div>
            )}
          </div>
        )}
        {loading ? null : (
          <div className="container-search-page">
            {clientsListType === "list" ? (
              <div>
                {!clients.length ? null : (
                  <div className="row mr-bottom-20">
                    <h2>Позвонить сегодня</h2>
                    <WaitForCallPanel list={clients} className={"warning"} />
                  </div>
                )}
              </div>
            ) : (
              <div>
                {clients ? (
                  <div className="row mr-bottom-20">
                    <InWorkPanel title="Позвонить сегодня" list={clients} />
                  </div>
                ) : null}
              </div>
            )}
          </div>
        )}

        <div className="container">
          {this.avalaybleTypes.length ? (
            <div className="clearfix mr-top-20 mr-bottom-20">
              <p className="sub-title col-xs-2">Фильтры поиска:</p>
              <hr />
              <div
                style={{
                  display: "flex",
                  width: "40%",
                  justifyContent: "space-between"
                }}
              >
                <span
                  style={{
                    marginLeft: 10
                  }}
                >
                  Тип
                </span>
                {this.renderType()}
              </div>
            </div>
          ) : null}
          <SearchFilters
            options={this.avalaybleTypes || []}
            onSubmit={this.handleFormFilterChange}
            values={this.state.types}
            multiple
            types={this.state.types}
          />
          <YMap
            placemarks={this.filterPlacemarks()}
            coords={this.state.filterCoords}
            isFetching={isPlacemarksLoading}
          />
        </div>
      </div>
    );
  }
}

SearchPage.propTypes = {
  placemarks: PropTypes.array,
  loadPlacemarks: PropTypes.func.isRequired,
  isPlacemarksLoading: PropTypes.bool,
  clientsLoading: PropTypes.bool,
  clientTypes: PropTypes.array,
  loadClients: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  clients: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  inProfitClients: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  waitCallClients: PropTypes.array,
  loadClientInProfit: PropTypes.func.isRequired,
  loadWaitCallClients: PropTypes.func.isRequired,
  clientsListType: PropTypes.string,
  profitListType: PropTypes.string
};

const mapStateToProps = state => ({
  placemarks: state.map.placemarks,
  isPlacemarksLoading: state.map.loading,
  clientTypes: state.webInterface.initData
    ? state.webInterface.initData.client_type
    : [],
  clients: state.clients.list,
  loading: state.clients.loading || state.clients.inProfitLoading,
  inProfitClients: state.clients.inProfitList,
  waitCallClients: state.clients.waitCallClientsList,
  clientsListType: state.clients.clientsListType,
  profitListType: state.clients.profitListType,
  filters: state.filtersReducer.filters
});

const mapDispatchToProps = dispatch => ({
  loadPlacemarks: filter => dispatch(loadPlacemarks(filter)),
  loadClientsInWorkFullList: () => dispatch(loadClientsInWorkFullList()),
  loadClients: (filter, pager) => dispatch(loadClients(filter, pager)),
  loadClientInProfit: () => dispatch(loadClientInProfit()),
  loadWaitCallClients: () => dispatch(loadWaitCallClients()),
  loadFilters: filter => dispatch(loadFilters(filter))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchPage);



// WEBPACK FOOTER //
// ./containers/SearchPage.js